import { render, staticRenderFns } from "./JcbSvg.vue?vue&type=template&id=8aa7fc36&scoped=true&"
import script from "./JcbSvg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./JcbSvg.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa7fc36",
  null
  
)

export default component.exports